import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import { Breadcrumbs, Typography, Box, Link } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const MuiBreadcrumbs = ({ categoryId, className }) => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    const fetchBreadcrumbs = async () => {
      try {
        const response = await axiosInstance.get(`/category/breadcrumbs/${categoryId}`);
        setBreadcrumbs(response.data);
      } catch (error) {
        console.error('Error fetching breadcrumbs:', error);
      }
    };

    fetchBreadcrumbs();
  }, [categoryId]);

  const orderedBreadcrumbs = breadcrumbs.slice().reverse();

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      className={className}
      my={2}
    >
      {orderedBreadcrumbs.map((crumb, index) => {
        const isLast = index === orderedBreadcrumbs.length - 1;
        return isLast ? (
          <Typography key={crumb.category_id} color="text.primary">
            {crumb.category_name}
          </Typography>
        ) : (
          <Link
            key={crumb.category_id}
            component={RouterLink}
            to={`/category/${crumb.category_id}`}
            underline="hover"
            color="inherit"
          >
            {crumb.category_name}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default MuiBreadcrumbs;
